export const QUIZ_ACTIONS = {
  SET_SELECTED_QUIZ: 'SET_SELECTED_QUIZ',
  SET_SELECTED_QUIZ_ID: 'SET_SELECTED_QUIZ_ID',
  ADD_ANSWER_TO_SELECTED_OPTIONS: 'ADD_ANSWER_TO_SELECTED_OPTIONS',
  INCREMENT_QUESTION_NUMBER: 'INCREMENT_QUESTION_NUMBER',
  DECREMENT_TIMER_VALUE: 'DECREMENT_TIMER_VALUE',
  RESET_TIMER_VALUE: 'RESET_TIMER_VALUE',
  RESET_QUIZ_STATE: 'RESET_QUIZ_STATE',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
};
